export default __webpack_public_path__ + "static/media/rap.06f6cde6.mp4";